export default "__VITE_ASSET__6c96d1fc__"